// Sprintlar. O'zbek tilida son bilan ot ko'plik olmaydi, shuning uchun har bir kalit bitta shaklda.
const sprintsUz = {
  sprints: {
    sprint: "Sprint",
    backlog: "Backlog",
    backlogTitle: "Backlog",
    allSprints: "Barcha sprintlar",
    activeSprints: "Faol sprintlar",
    planASprint: "Sprint rejalashtirish",
    next: "keyingi",
    state: { planned: "Rejalashtirilgan", active: "Faol", completed: "Tugagan" },
    unit: { pts: "{{n}} ball", tasks: "{{n}} ta vazifa" },
    points: "Story ballari",
    hours: "Soatlar",
    estimate: "Baho",
    changeEstimate: "Bahoni o'zgartirish",
    changeSprint: "Sprintni o'zgartirish",
    quickPicks: "Tez tanlash",
    pointsPlaceholder: "Istalgan son",
    pointsInvalid: "0 dan 1000 gacha son kiriting.",
    followsParent: "Ota vazifadagidek",
    unestimated: "Baholanmagan",
    loggedOfEstimate: "Sarflangan / dastlabki baho",
    notVerified: "Tayyor, tekshirilmagan",
    notVerifiedShort: "Tekshirilmagan",
    notVerifiedHint: "Tayyor, lekin testdan hali o'tmagan",
    nNotVerified: "{{n}} tekshirilmagan",
    nRemaining: "{{n}} qoldi",
    progress: "Sprint jarayoni",
    progressText: "{{done}} / {{total}}",
    setCapacity: "Sig‘imni belgilash",
    capacity: "Sig'im",
    forecast_one: "Oxirgi sprint bo‘yicha prognoz: {{amount}}",
    forecast_few: "Oxirgi {{count}} ta sprint bo‘yicha prognoz: {{amount}}",
    forecast: "Oxirgi {{count}} ta sprint bo‘yicha prognoz: {{amount}}",
    forecastBasis: {
      person_days: "Yaqingi sprintlarda bir mavjud kishi-kunga to‘g‘ri kelgan bajarilgan ish × shu sprintning kishi-kunlari",
      working_days: "Yaqingi sprintlarda bir ish kuniga to‘g‘ri kelgan bajarilgan ish × shu sprintning ish kunlari",
    },
    overForecast: "Prognozdan +{{n}} ko‘p",
    overCapacityBy: "Sig‘imdan +{{n}} ko‘p",
    overBoth: "Prognozdan ham, sig‘imdan ham ko‘p",
    daysAround: "{{available}}/{{working}} kun",
    daysOffHint: "Shu sprintdagi ish kunlari (dam olish kunlarisiz)",
    afterDaysOff: "{{capacity}} × {{available}}/{{working}} kun = {{effective}}",
    daysOff: {
      title: "Ishlamaydigan kunlar",
      titleFor: "Ishlamaydigan kunlar — {{name}}",
      hint: "Ta’til va kasallik kunlari. Ular barcha loyihalarning rejalangan sprintlarida sig‘imni kamaytiradi.",
      from: "Dan",
      to: "Gacha",
      note: "Izoh",
      notePlaceholder: "Ta’til",
      add: "Qo‘shish",
      edit: "Tahrirlash",
      save: "Saqlash",
      remove: "O‘chirish",
      none: "Ishlamaydigan kunlar rejalashtirilmagan.",
      merged: "Ustma-ust tushgan kunlar bittaga birlashtiriladi.",
      button: "Ishlamaydigan kunlar",
      nDays_one: "{{count}} kun",
      nDays_few: "{{count}} kun",
      nDays: "{{count}} kun",
    },
    capacityOf: "{{total}} / {{capacity}}",
    over: "+{{n}} ortiqcha",
    overCapacity: "Sig'imdan oshgan",
    overall: "Butun jamoa",
    capacityFor: "{{name}} sig'imi",
    noCap: "Cheklovsiz",
    capacityInvalid: "Sig'im 0 yoki undan katta son bo'lishi kerak.",
    capacityHint: {
      points: "Story ballarida. Bo'sh maydon — cheklovsiz.",
      hours: "Soatlarda. Bo'sh maydon — cheklovsiz.",
      none: "Vazifalarda. Bo'sh maydon — cheklovsiz.",
    },
    perPerson: "Har bir odamning yuklamasi",
    startsIn: "{{count}} kundan keyin boshlanadi",
    startsIn_one: "{{count}} kundan keyin boshlanadi",
    startsToday: "Bugun boshlanadi",
    daysLeft: "{{count}} kun qoldi",
    daysLeft_one: "{{count}} kun qoldi",
    lastDay: "Oxirgi kun",
    endedAgo: "{{count}} kun oldin tugagan",
    endedAgo_one: "{{count}} kun oldin tugagan",
    nTasks: "{{count}} ta vazifa",
    nTasks_one: "{{count}} ta vazifa",
    nUnestimated: "{{count}} ta baholanmagan",
    nSelected: "{{count}} ta tanlandi",
    doneOf: "{{total}} dan {{done}} tayyor",
    filtered: "filtrlangan",
    groupBySprint: "Sprint bo'yicha",
    sortBySprint: "Sprint",

    createSprint: "Sprint yaratish",
    selection: "Tanlangan vazifalar",
    moveTo: "Ko'chirish",
    moveTaskTo: "{{key}} ni ko'chirish…",
    selectTask: "{{key}} ni tanlash",
    clearSelection: "Tanlovni bekor qilish",
    noSprintsTitle: "Rejalashtirilgan sprint yo'q",
    noSprintsBody: "Sprint yarating va quyidagi backlogdan vazifalarni unga sudrab o'tkazing.",
    noSprintsViewer: "Sprintlarni bu yerda loyiha menejeri rejalashtiradi.",
    emptySprint: "Bu sprintda hali vazifa yo'q.",
    emptySprintDrop: "Vazifalarni backlogdan bu yerga sudrang yoki vazifadagi «Ko'chirish»ni tanlang.",
    emptySprintMove: "Vazifani bu sprintga qo'shish uchun undagi «Ko'chirish»ni tanlang.",
    emptyBacklog: "Backlog bo'sh: barcha ochiq vazifalar sprintlarda.",
    addGoal: "Maqsad qo'shish",
    actionsFor: "{{name}} uchun boshqa amallar",
    edit: "Sprintni tahrirlash",
    currentAndPlanned: "Joriy va rejalashtirilgan",
    completedSprints: "Yakunlangan",
    openBacklog: "Backlogni ochish",

    name: "Nomi",
    goal: "Maqsad",
    goalHint: "Jamoa bu sprintda nimaga erishmoqchi.",
    startDate: "Boshlanish sanasi",
    endDate: "Tugash sanasi",
    endBeforeStart: "Tugash sanasi boshlanishdan oldin bo'lishi mumkin emas.",
    create: "Sprint yaratish",
    createTitle: "Yangi sprint",
    editTitle: "{{name}} ni tahrirlash",
    created: "{{name}} yaratildi",
    saved: "Sprint saqlandi",
    start: "Sprintni boshlash",
    startTitle: "{{name}} ni boshlash",
    started: "{{name}} boshlandi",
    anotherActive: "{{name}} hali faol. Boshqa sprintni boshlashdan oldin uni yakunlang.",
    emptyWarning: "Bu sprintda hali vazifa yo'q. Uni boshlab, vazifalarni keyin qo'shish mumkin.",
    startSummary: "{{count}} ta vazifa, majburiyat: {{total}}.",
    startSummary_one: "{{count}} ta vazifa, majburiyat: {{total}}.",
    complete: "Sprintni yakunlash",
    completeTitle: "{{name}} ni yakunlash",
    completed: "{{name}} yakunlandi",
    allDone: "Sprintdagi barcha vazifalar tayyor. Yakunlangach hisobot muzlatiladi.",
    unfinishedIntro: "{{count}} ta vazifa tugallanmagan:",
    unfinishedIntro_one: "{{count}} ta vazifa tugallanmagan:",
    moveUnfinished: "Tugallanmagan vazifalarni qayerga ko'chirish",
    destNext: "Keyingi sprint: {{name}}",
    destNextNone: "Keyingi rejalashtirilgan sprint",
    destNextNoneHint: "Rejalashtirilgan sprint yo'q. Yangi sprintni tanlang.",
    destNew: "Yangi sprint",
    destNewHint: "Hozir, shu sprintdan keyin yaratiladi.",
    destBacklog: "Backlog",
    destBacklogHint: "Sprintdan tashqarida, keyin qayta rejalashtirish uchun.",
    subtasksFollow: "Kichik vazifalar ota vazifa bilan birga ko'chadi.",
    deleteTitle: "{{name}} o'chirilsinmi?",
    deleteBody: "Uning {{count}} ta vazifasi backlogga qaytadi. Buni bekor qilib bo'lmaydi.",
    deleteBody_one: "Uning {{count}} ta vazifasi backlogga qaytadi. Buni bekor qilib bo'lmaydi.",
    deleted: "{{name}} o'chirildi",

    completedBanner: "Bu sprint {{date}} da yakunlangan. Doska faqat ko'rish uchun.",
    openReport: "Hisobotni ochish",
    openSprint: "Sprintni ochish",
    report: "Hisobot",

    reportTitle: "{{name}} hisoboti",
    tabReport: "Hisobot",
    tabRetro: "Retrospektiva",
    reportPlannedTitle: "Hisobot sprint boshlanganda paydo bo'ladi",
    reportPlannedBody: "Sprint boshlangach, bu yerda majburiyat, kuyish grafigi va hajm o'zgarishlari ko'rinadi.",
    committed: "Majburiyat",
    completedLabel: "Bajarildi",
    completedSplit: "{{committed}} rejadan + {{added}} qo'shilgan",
    added: "Qo'shildi",
    removed: "Olib tashlandi",
    estimateChange: "Baholar {{n}}",
    notVerifiedTiles: "Testi o'tmagan tayyor vazifalar",
    burndown: "Kuyish grafigi",
    burndownPoints: "Ochiq vazifalardagi story ballari, kunlar bo'yicha.",
    burndownHours: "Qolgan vaqt, kunlar bo'yicha.",
    burndownTasks: "Ochiq vazifalar, kunlar bo'yicha.",
    burndownDayOne: "Birinchi kun: {{initial}} qoldi. Chiziq kunma-kun to'ladi.",
    remainingLine: "Qoldi",
    idealLine: "Ideal",
    scopeChange: "Hajm o'zgarishi",
    listCompleted: "Bajarildi",
    listNotCompleted: "Bajarilmadi",
    listRemoved: "Sprintdan olib tashlangan",
    listAdded: "Boshlangandan keyin qo'shilgan",
    listNotVerified: "Tayyor, tekshirilmagan",
    listCarriedMore: "Bir martadan ko'p ko'chirilgan",
    listEmpty: "Yo'q",
    addedMark: "qo'shilgan",
    stillHere: "shu sprintda",
    timesCarried: "{{count}} marta ko'chirilgan",
    timeByPerson: "Odamlar bo'yicha sarflangan vaqt",
    timeTotal: "{{estimate}} bahoga nisbatan {{logged}} sarflandi",
    noTimeLogged: "Bu sprintda vaqt yozilmagan.",
    velocity: "Jamoa tezligi",
    velocityAverage: "O'rtacha bajarilgan: {{n}} (oxirgi 6 ta yakunlangan sprint)",
    velocityNone: "Tezlik sprintlar yakunlangach ko'rinadi.",
    velocityOne: "Hozircha bitta sprint yakunlangan: tezlik yana bir nechtasidan keyin aniqroq bo'ladi.",

    retro: { well: "Nima yaxshi bo'ldi", improve: "Nima yaxshi bo'lmadi", action: "Harakatlar" },
    retroHint: { well: "Shunday davom etamiz.", improve: "Jamoani nima sekinlashtirdi.", action: "Aniq qadamlar, har biriga mas'ul." },
    retroAdd: { well: "Yaxshi bo'lgan narsa…", improve: "Yaxshi bo'lmagan narsa…", action: "Harakat…" },
    retroIntro: "Jamoadagi istalgan kishi yozuv qo'shishi mumkin. O'zgarishlar darhol saqlanadi, sprint yakunlangandan keyin ham.",
    retroReadOnly: "Jamoaning bu sprint bo'yicha yozuvlari.",
    retroEmpty: "Hozircha bo'sh.",
    retroDelete: "Yozuvni o'chirish",
    retroDone: "Bajarildi",
    retroOwner: "Mas'ul tayinlash",
    retroNoOwner: "Mas'ul yo'q",
  },
  timer: {
    section: "Vaqt",
    original: "Dastlabki baho",
    loggedLabel: "Sarflangan",
    remaining: "Qolgan",
    setByHand: "qo'lda belgilangan",
    setRemaining: "Qolgan vaqtni belgilash",
    automatic: "Avtomatik",
    barLabel: "{{logged}} sarflangan, {{remaining}} qolgan",
    subtaskNote: "Kichik vazifadagi vaqt ota vazifa bahosiga hisoblanadi.",
    logTime: "Vaqt yozish",
    logTitle: "{{key}} ga vaqt yozish",
    editTitle: "{{key}} dagi vaqtni tahrirlash",
    stoppedTitle: "{{key}} dagi taymer to'xtatildi",
    stoppedBody: "Vaqt saqlandi. Kerak bo'lsa, tuzating.",
    keep: "Shundayligicha qoldirish",
    duration: "Sarflangan vaqt",
    durationHint: "Masalan: 2h 30m, 45m yoki 1.5h",
    durationInvalid: "Shunday yozing: 2h 30m, 45m yoki 1.5h.",
    durationRange: "1 daqiqadan 24 soatgacha.",
    date: "Sana",
    dateHint: "Bo'sh qolsa — bugun",
    note: "Izoh",
    logged: "{{time}} yozildi",
    entrySaved: "Vaqt yozuvi saqlandi",
    editEntry: "Yozuvni tahrirlash",
    deleteEntry: "Yozuvni o'chirish",
    deleteTitle: "Bu vaqt yozuvi o'chirilsinmi?",
    deleteBody: "{{date}} dagi {{time}} o'chiriladi.",
    review: "Tekshiring",
    reviewHint: "Unutilgan taymer 12 soatdan keyin o'zi to'xtadi. Vaqtni tekshirib, saqlang.",
    start: "Taymerni boshlash",
    stop: "Taymerni to'xtatish",
    startOn: "{{key}} da taymerni boshlash",
    stopOn: "{{key}} dagi taymerni to'xtatish",
    running: "{{key}} da taymer ishlayapti: {{time}}",
  },
  sprintSettings: {
    scrumTitle: "Scrum",
    scrumIntro: "Sprintlar, backlog, baholar, vaqt hisobi, rejalash pokeri, standup va dam olish kunlari.",
    scrumLabel: "Bu loyihada Scrum'dan foydalanish",
    scrumHint: "O'chirilsa, bular yashiriladi va avtomatik sprintlar to'xtatib turiladi. Hech narsa o'chib ketmaydi: yoqilganda hammasi qaytadi.",
    timezoneTitle: "Vaqt mintaqasi",
    timezoneIntro: "Takrorlanuvchi vazifalar va oqim grafiklari shu vaqt mintaqasidan foydalanadi.",
    title: "Sprintlar",
    intro: "Loyiha ishni qanday baholaydi va sprintlarni qanday yuritadi.",
    unit: "Baho birligi",
    units: { points: "Story ballari", hours: "Soatlar", none: "Yo'q (vazifalar soni)" },
    unitHint: "Sprint jami, sig'im va kuyish grafigi shu birlikda hisoblanadi.",
    unitLocked: "Birlikni o'zgartirish uchun faol sprintni yakunlang.",
    length: "Sprint davomiyligi",
    weeks: "{{count}} hafta",
    weeks_one: "{{count}} hafta",
    timezone: "Vaqt mintaqasi",
    timezoneHint: "Sprint kunlari shu mintaqada yarim tunda boshlanadi va tugaydi.",
    timezoneSuggested: "Brauzeringizdan olindi. Qo'llash uchun saqlang.",
    timezoneUnknown: "Ro'yxatdan vaqt mintaqasini tanlang.",
    workingDays: "Ish kunlari",
    workingDaysHint: "Boshqa kunlarda ideal chiziq pasaymaydi.",
    workingDaysNone: "Kamida bitta ish kunini tanlang.",
    day: { mon: "Du", tue: "Se", wed: "Ch", thu: "Pa", fri: "Ju", sat: "Sh", sun: "Ya" },
    dayLong: { mon: "Dushanba", tue: "Seshanba", wed: "Chorshanba", thu: "Payshanba", fri: "Juma", sat: "Shanba", sun: "Yakshanba" },
    timeLogging: "Vaqt hisobi",
    timeLoggingHint: "Vazifalarga vaqt yozish va taymer. Vaqt yozilgan sari qolgan vaqt kamayadi.",
    timeLoggingHoursOnly: "Baho birligi soat bo'lganda mavjud.",
    auto: "Avtomatik sprintlar",
    autoHint: "Mixla sprintni tugash sanasida yakunlaydi, tugallanmagan vazifalarni keyingisiga ko'chiradi va uni boshlaydi.",
    autoWeekday: "Sprintlar boshlanadigan kun",
    autoLength: "Har bir sprint {{count}} hafta davom etadi (yuqoridagi davomiylik).",
    autoLength_one: "Har bir sprint {{count}} hafta davom etadi (yuqoridagi davomiylik).",
    autoWillPlan: "Saqlangach, {{name}} darhol rejalashtiriladi.",
    autoKeeps: "Mixla keyingi sprintni doim rejalashtirilgan holda saqlaydi.",
    unsaved: "Saqlanmagan o'zgarishlar bor",
  },
};

export default sprintsUz;
